import { JSX, Show } from "solid-js";
import { useTelescopeContext } from "@hubble/telescope";
import { UPIApp } from "~/data/upi_apps";
import { PhosphorIcon } from "~/widgets/icons";

export interface UpiAppTileProps {
  app: UPIApp;
  isLoading: boolean;
  onClick: () => void;
}

export function UpiAppTile(props: UpiAppTileProps): JSX.Element {
  const { components } = useTelescopeContext();

  return (
    <button
      type="button"
      class="flex flex-1 items-center justify-between rounded-lg border border-stroke-1 bg-background-normal-primary py-3 pl-4 pr-2 transition-opacity hover:opacity-80 active:opacity-70 disabled:cursor-not-allowed disabled:opacity-50"
      onClick={props.onClick}
      disabled={props.isLoading}
    >
      <div class="flex h-6 items-center">
        <Show
          when={!props.isLoading}
          fallback={<components.Loader size="small" />}
        >
          <img
            src={props.app.icon}
            alt={props.app.name}
            class="h-5 max-w-[60px] object-contain"
          />
        </Show>
      </div>
      <div class="size-6">
        <PhosphorIcon
          name="caret-right"
          fontSize={24}
          class="text-text-normal-tertiary"
        />
      </div>
    </button>
  );
}
